// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Ww_x","rightAdornment":"Header_rightAdornment__FQxEh"};